import React from 'react';
import {useHistory} from "react-router-dom";
import {can} from "../../../_common/components/Permissions";
import {permissionTypes as T, subjects as S} from "../../../_common/constants/permissionSubjects";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {pathnames as P} from "../../../_common/constants/pathnames";
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import ButtonAction from '../../../_common/components/ButtonAction';

const ButtonDetails = ({shumaID, firmShumaID}) => {
  const history = useHistory();
  const handleEditInspection = () => {
    history.push(P.NEW_INSPECTION_DETAILS_LINK(shumaID), {firmShumaID})
  };

  return (
    <ButtonAction
      iconButtonType={'primary'}
      variant={'icon'}
      label={
        <img
          src={toAbsoluteUrl('/media/common/Edit_primary.svg')}
          alt={'redirect'} className="w-20px h-20px"
        />
      }
      title={TTS.EDIT_INSPECTION}
      onClick={() => handleEditInspection()}
      disabled={!can(T.FULL, S.INSPECTIONS_PAGE)}
      customClassnames={'my-1'}
    />
  );
};

export default ButtonDetails;